export interface BZTelecomItem {
  id: number;
  title: string;
  category: string;
  description: string;
  aiSuggestion: string;
  kpiScore: number;
  imageUrl?: string;
  isCompleted?: boolean;
  inKnowledgeBase?: boolean;
  scoreDany?: number;
  scoreYannick?: number;
  scoreFrancois?: number;
  visionDany?: string;
  visionYannick?: string;
  visionFrancois?: string;
}

export const bzTelecomData: BZTelecomItem[] = [
  {
    id: 1,
    title: "Téléphonie Cloud Asterisk",
    category: "Service Principal",
    description: "Systèmes de téléphonie Cloud basés sur Asterisk avec service humain inclus - le différenciateur clé de BZ Telecom.",
    aiSuggestion: "Découvrez notre téléphonie Cloud Asterisk : technologie avancée avec service humain exceptionnel pour votre entreprise.",
    kpiScore: 95,
    imageUrl: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80",
    isCompleted: true,
    inKnowledgeBase: true,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 5,
    visionDany: "BZ Telecom, c'est notre compagnie sœur qui excelle dans la téléphonie Cloud. Asterisk, c'est la technologie, mais le service humain inclus, c'est ce qui nous différencie. C'est ça, l'excellence BZ.",
    visionYannick: "La téléphonie Cloud Asterisk de BZ Telecom, c'est un excellent produit avec un service humain qui fait toute la différence. Nos clients apprécient cette approche personnalisée.",
    visionFrancois: "Techniquement, Asterisk est une plateforme VoIP open-source robuste et flexible. BZ Telecom l'utilise pour offrir des solutions télécom complètes avec un support humain exceptionnel."
  },
  {
    id: 2,
    title: "Service Client & Support 24/7",
    category: "Service",
    description: "Service tout inclus 24/7 offert par une équipe dévouée. Support technique prioritaire et accompagnement personnalisé.",
    aiSuggestion: "Bénéficiez d'un support technique 24/7 avec une équipe dévouée qui comprend vos besoins télécom.",
    kpiScore: 92,
    imageUrl: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80",
    isCompleted: true,
    inKnowledgeBase: true,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 4,
    visionDany: "Le service client, c'est notre différenciateur. On n'est pas juste une technologie, on est des humains qui comprennent les besoins de nos clients. C'est ça, BZ Telecom.",
    visionYannick: "Le support 24/7 avec service humain, c'est ce qui nous distingue. Nos clients savent qu'ils peuvent compter sur nous, peu importe l'heure.",
    visionFrancois: "Techniquement, le support 24/7 nécessite une infrastructure robuste et une équipe bien formée. C'est un engagement fort envers nos clients."
  },
  {
    id: 3,
    title: "Infrastructure Télécom Redondante",
    category: "Infrastructure",
    description: "Infrastructure télécom robuste avec redondance N+1, génératrices, UPS et standards de qualité élevés pour une fiabilité maximale.",
    aiSuggestion: "Profitez d'une infrastructure télécom redondante et fiable pour garantir la continuité de vos communications.",
    kpiScore: 90,
    imageUrl: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&q=80",
    isCompleted: true,
    scoreDany: 5,
    scoreYannick: 4,
    scoreFrancois: 5,
    visionDany: "L'infrastructure, c'est la base. On ne peut pas offrir un service fiable sans une infrastructure solide. Redondance, génératrices, UPS, tout est pensé pour la fiabilité.",
    visionYannick: "L'infrastructure redondante, c'est rassurant pour nos clients. Ils savent que leur téléphonie ne tombera pas. C'est un argument de vente puissant.",
    visionFrancois: "Techniquement, la redondance N+1, les génératrices et les UPS garantissent une disponibilité maximale. C'est essentiel pour un service télécom professionnel."
  },
  {
    id: 4,
    title: "Câblage Structuré",
    category: "Infrastructure",
    description: "Services de câblage structuré pour infrastructures télécom et réseau. Installation professionnelle selon les standards de l'industrie.",
    aiSuggestion: "Optez pour un câblage structuré professionnel pour optimiser votre infrastructure télécom et réseau.",
    kpiScore: 88,
    imageUrl: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800&q=80",
    isCompleted: true,
    scoreDany: 4,
    scoreYannick: 4,
    scoreFrancois: 5,
    visionDany: "Le câblage structuré, c'est la fondation. Sans ça, rien ne fonctionne bien. On fait ça selon les standards, professionnellement.",
    visionYannick: "Le câblage structuré, c'est un service complémentaire qui renforce notre offre globale. C'est pratique pour nos clients.",
    visionFrancois: "Techniquement, le câblage structuré doit respecter les normes TIA/EIA et les standards de l'industrie. C'est essentiel pour la performance."
  },
  {
    id: 5,
    title: "Fibre Optique",
    category: "Infrastructure",
    description: "Solutions de fibre optique pour connectivité haute performance. Installation et maintenance de réseaux fibre optique.",
    aiSuggestion: "Découvrez nos solutions fibre optique pour une connectivité haute performance et fiable.",
    kpiScore: 87,
    imageUrl: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80",
    isCompleted: true,
    scoreDany: 4,
    scoreYannick: 4,
    scoreFrancois: 5,
    visionDany: "La fibre optique, c'est l'avenir. On offre des solutions complètes, de l'installation à la maintenance. C'est professionnel.",
    visionYannick: "La fibre optique, c'est un service qui complète notre offre. Nos clients apprécient cette expertise technique.",
    visionFrancois: "Techniquement, la fibre optique offre des débits supérieurs et une meilleure fiabilité que le cuivre. C'est la technologie moderne."
  },
  {
    id: 6,
    title: "Formation & Certification",
    category: "Formation",
    description: "Programmes de formation structurés pour maîtriser Asterisk et les systèmes BZ Telecom. Bootcamps et certification interne.",
    aiSuggestion: "Formez votre équipe avec nos programmes structurés pour maîtriser la téléphonie Cloud Asterisk.",
    kpiScore: 85,
    imageUrl: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&q=80",
    isCompleted: true,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 4,
    visionDany: "La formation, c'est essentiel. On ne peut pas vendre ce qu'on ne comprend pas. Les bootcamps avec Martin, c'est la clé du succès.",
    visionYannick: "La formation, c'est un investissement dans l'équipe. Plus on forme, mieux on vend. C'est un cycle vertueux.",
    visionFrancois: "Techniquement, la formation doit être structurée et pratique. Les bootcamps permettent de maîtriser rapidement les concepts clés."
  },
  {
    id: 7,
    title: "Gouvernance & RACI",
    category: "Gouvernance et Conformité",
    description: "Matrice RACI claire pour la gouvernance BZ Telecom. Responsabilités définies entre BZ et BZ Telecom avec Martin Carrier comme président.",
    aiSuggestion: "Comprenez la gouvernance BZ Telecom avec notre matrice RACI claire et structurée.",
    kpiScore: 93,
    imageUrl: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80",
    isCompleted: true,
    inKnowledgeBase: true,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 5,
    visionDany: "La gouvernance, c'est la clé. On a une matrice RACI claire : Martin est Accountable, Antoine et son équipe sont Responsible. C'est structuré, c'est professionnel.",
    visionYannick: "La gouvernance RACI, c'est ce qui permet de fonctionner efficacement. Chacun sait son rôle, ses responsabilités. C'est rassurant.",
    visionFrancois: "Techniquement, la matrice RACI définit clairement qui fait quoi. C'est essentiel pour éviter les conflits et assurer la responsabilité."
  },
  {
    id: 21,
    title: "Responsabilité des ventes chez BZ Telecom",
    category: "Gouvernance et Conformité",
    description:
      "Cadre clair du rôle ventes pour BZ Telecom : génération de leads, suivi rigoureux du tableau des leads, accompagnement client, lien relationnel en cas de panne et suivi marketing/Google Ads.",
    aiSuggestion:
      "Utilisez cette tuile pour clarifier ce que l'équipe ventes doit porter concrètement dans l'écosystème BZ Telecom.",
    kpiScore: 92,
    imageUrl: "https://images.unsplash.com/photo-1556740749-887f6717d7e4?w=800&q=80",
    isCompleted: true,
    inKnowledgeBase: false,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 4,
    visionDany:
      "Une équipe ventes mature ne fait pas juste ouvrir des portes. Elle porte le lien, la rigueur du suivi et la qualité de la relation avec BZ Telecom.",
    visionYannick:
      "Quand les responsabilités ventes sont claires, le pipeline avance mieux, les suivis se font et le client sent qu'il est pris en charge du début à la suite.",
    visionFrancois:
      "Même côté technique, une bonne structure ventes réduit les angles morts: moins d'information perdue, meilleure coordination et meilleure communication pendant les incidents.",
  },
  {
    id: 8,
    title: "KPIs & Performance",
    category: "Performance",
    description: "Suivi des KPIs d'actions et de résultats pour BZ Telecom. Objectif critique : +8,000$/mois MRR d'ici décembre 2026.",
    aiSuggestion: "Suivez vos KPIs BZ Telecom pour mesurer la performance et atteindre vos objectifs de croissance.",
    kpiScore: 91,
    imageUrl: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80",
    isCompleted: true,
    inKnowledgeBase: true,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 4,
    visionDany: "Les KPIs, c'est la mesure de notre succès. On contrôle les actions, pas les résultats. Mais l'objectif +8k$/mois MRR, c'est critique. C'est la survie du contrat.",
    visionYannick: "Les KPIs, c'est ce qui nous permet de suivre la performance. Actions contrôlables : propositions, follow-ups, CRM. Résultats : MRR, clients, closing.",
    visionFrancois: "Techniquement, les KPIs doivent être mesurables et actionnables. On suit les actions qu'on contrôle, et on mesure les résultats pour ajuster."
  },
  {
    id: 9,
    title: "Roadmap 2026",
    category: "Stratégie",
    description: "Plan d'action trimestriel pour 2026 avec jalons clés, KPIs et objectifs MRR. Q1 : Fondations, Q2 : Accélération, Q3 : Scaling, Q4 : Push final.",
    aiSuggestion: "Explorez la roadmap 2026 de BZ Telecom avec ses jalons trimestriels et objectifs de croissance.",
    kpiScore: 89,
    imageUrl: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
    isCompleted: true,
    inKnowledgeBase: true,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 4,
    visionDany: "La roadmap 2026, c'est notre plan d'action. Q1 fondations, Q2 accélération, Q3 scaling, Q4 push final. Chaque trimestre a ses jalons, ses KPIs, ses objectifs MRR.",
    visionYannick: "La roadmap, c'est ce qui guide nos actions. On sait où on va, comment on y va, et comment on mesure le succès. C'est structuré.",
    visionFrancois: "Techniquement, la roadmap doit être réaliste et mesurable. Chaque trimestre doit avoir des jalons clairs et des KPIs définis."
  },
  {
    id: 10,
    title: "Pricing Rigide & Standardisé",
    category: "Commercial",
    description: "Cadre de pricing rigide et standardisé avec packages Essentiel (175$/mois), Professionnel (275$/mois) et Entreprise (425$/mois). Pricing transparent et non-négociable.",
    aiSuggestion: "Découvrez notre pricing rigide et standardisé pour simplifier vos ventes et garantir la transparence.",
    kpiScore: 88,
    imageUrl: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&q=80",
    isCompleted: true,
    inKnowledgeBase: true,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 4,
    visionDany: "Le pricing rigide, c'est la clé. Pas de négociation, prix transparent, standardisé. Ça simplifie les ventes et ça permet l'outil de vente en ligne.",
    visionYannick: "Le pricing rigide, c'est un avantage commercial. Pas de friction, pas de négociation, prix clair immédiatement. Ça accélère le closing.",
    visionFrancois: "Techniquement, le pricing rigide permet de prévoir les revenus et de simplifier les processus. C'est plus efficace."
  },
  {
    id: 11,
    title: "Outil de Vente en Ligne",
    category: "Innovation",
    description: "Configurateur web interactif avec pricing automatique. Prospect configure son système → Prix instantané → Proposition PDF générée automatiquement.",
    aiSuggestion: "Utilisez notre outil de vente en ligne pour configurer et générer des propositions automatiquement.",
    kpiScore: 82,
    imageUrl: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
    isCompleted: false,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 3,
    visionDany: "L'outil de vente en ligne, c'est l'innovation. Prospect configure, prix instantané, proposition générée. Self-service 24/7, réduction cycle vente. Lancement Q2 2026.",
    visionYannick: "L'outil de vente en ligne, c'est un game changer. Ça réduit le cycle de vente, ça permet le self-service, ça génère des leads qualifiés. C'est puissant.",
    visionFrancois: "Techniquement, l'outil nécessite une intégration avec le système de pricing et un générateur de PDF. C'est faisable mais demande du développement."
  },
  {
    id: 12,
    title: "Stratégies Marketing",
    category: "Marketing",
    description: "Thought leadership LinkedIn, programme de référencement, webinaires mensuels, partenariats verticaux, contenu vidéo YouTube pour générer des leads.",
    aiSuggestion: "Découvrez nos stratégies marketing pour positionner BZ Telecom comme référence téléphonie Cloud au Québec.",
    kpiScore: 86,
    imageUrl: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80",
    isCompleted: true,
    scoreDany: 4,
    scoreYannick: 5,
    scoreFrancois: 3,
    visionDany: "Le marketing, c'est la visibilité. Thought leadership LinkedIn, webinaires, référencement, partenariats. On devient LA référence téléphonie Cloud au Québec.",
    visionYannick: "Le marketing, c'est ce qui génère les leads. Plus on est visibles, plus on génère d'opportunités. C'est un investissement dans la croissance.",
    visionFrancois: "Techniquement, le marketing nécessite du contenu, de la stratégie et de la mesure. C'est important mais pas mon domaine principal."
  },
  {
    id: 13,
    title: "Tactiques Ventes",
    category: "Ventes",
    description: "Audit télécom gratuit, période d'essai 30 jours, ROI calculator interactif, bundles sectoriels, social proof agressif pour améliorer le closing.",
    aiSuggestion: "Utilisez nos tactiques de vente éprouvées pour améliorer votre taux de closing et réduire le cycle de vente.",
    kpiScore: 87,
    imageUrl: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80",
    isCompleted: true,
    scoreDany: 4,
    scoreYannick: 5,
    scoreFrancois: 3,
    visionDany: "Les tactiques de vente, c'est ce qui fait la différence. Audit gratuit, essai 30 jours, ROI calculator, bundles. On réduit les objections, on accélère le closing.",
    visionYannick: "Les tactiques de vente, c'est mon domaine. Audit gratuit pour entrer, essai pour réduire le risque, ROI calculator pour convaincre. C'est structuré.",
    visionFrancois: "Techniquement, les tactiques de vente nécessitent des outils et des processus. C'est important pour la performance commerciale."
  },
  {
    id: 14,
    title: "Innovation IA",
    category: "Innovation",
    description: "Prospection AI automatisée LinkedIn, chatbot qualification leads, analyse appels AI pour coaching équipe ventes. Innovation technologique pour améliorer la performance.",
    aiSuggestion: "Explorez nos innovations IA pour automatiser la prospection et améliorer la performance commerciale.",
    kpiScore: 80,
    imageUrl: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80",
    isCompleted: false,
    scoreDany: 5,
    scoreYannick: 4,
    scoreFrancois: 4,
    visionDany: "L'IA, c'est l'avenir. Prospection automatisée, chatbot qualification, analyse appels. On utilise la technologie pour améliorer la performance. C'est innovant.",
    visionYannick: "L'IA, c'est un outil puissant. Ça automatise, ça qualifie, ça analyse. Ça libère du temps pour les vendeurs. C'est efficace.",
    visionFrancois: "Techniquement, l'IA nécessite des modèles, des données et de l'intégration. C'est faisable mais demande de l'expertise."
  },
  {
    id: 15,
    title: "Comité BZ Telecom",
    category: "Gouvernance et Conformité",
    description: "Rencontre mensuelle pour révision performance, ajustements tactiques et alignment stratégique. Participants : Martin, Dany, Antoine, Jérôme, Dany.",
    aiSuggestion: "Participez au comité BZ Telecom pour aligner stratégie et tactiques avec l'équipe de direction.",
    kpiScore: 90,
    imageUrl: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80",
    isCompleted: true,
    inKnowledgeBase: true,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 4,
    visionDany: "Le comité, c'est la gouvernance en action. Rencontre mensuelle, révision KPIs, alignment stratégique. C'est structuré, c'est professionnel.",
    visionYannick: "Le comité, c'est ce qui permet l'alignment. On se rencontre, on revoit, on ajuste. C'est essentiel pour la performance.",
    visionFrancois: "Techniquement, le comité doit être structuré avec un ordre du jour clair et des actions définies. C'est important pour l'efficacité."
  },
  {
    id: 16,
    title: "Vidéos Sora2 IA",
    category: "Marketing",
    description: "Capsules vidéo trimestrielles générées avec IA Sora2. Format court et engageant : tips télécom, success stories clients, features spotlight.",
    aiSuggestion: "Découvrez nos capsules vidéo IA Sora2 pour promouvoir BZ Telecom de manière innovante.",
    kpiScore: 78,
    imageUrl: "https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=800&q=80",
    isCompleted: false,
    scoreDany: 5,
    scoreYannick: 4,
    scoreFrancois: 3,
    visionDany: "Les vidéos Sora2, c'est l'innovation marketing. Capsules trimestrielles générées avec IA, format court, engageant. C'est moderne, c'est efficace.",
    visionYannick: "Les vidéos Sora2, c'est un moyen de se démarquer. Contenu généré avec IA, format court, partageable. C'est visuel, c'est impactant.",
    visionFrancois: "Techniquement, Sora2 nécessite des prompts et de la post-production. C'est innovant mais demande de l'expertise."
  },
  {
    id: 17,
    title: "Prise de Besoin avec Martin",
    category: "Stratégie",
    description: "Spécifications d'exigences et prise de besoin structurée avec Martin Carrier. Questions business et opérationnelles pour comprendre parfaitement la vision BZ Telecom.",
    aiSuggestion: "Participez à la prise de besoin avec Martin pour comprendre la vision et les attentes de BZ Telecom.",
    kpiScore: 92,
    imageUrl: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80",
    isCompleted: true,
    inKnowledgeBase: true,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 4,
    visionDany: "La prise de besoin avec Martin, c'est essentiel. On doit comprendre sa vision, ses attentes, ses objectifs. C'est la base de tout.",
    visionYannick: "La prise de besoin, c'est ce qui permet l'alignment. On pose les bonnes questions, on comprend, on s'aligne. C'est structuré.",
    visionFrancois: "Techniquement, la prise de besoin doit être structurée avec des questions claires et une documentation complète. C'est important."
  },
  {
    id: 18,
    title: "Partenariat Stratégique BZ/BZ Telecom",
    category: "Stratégie",
    description: "Partenariat stratégique entre BZ et BZ Telecom. Équipe Ventes & Marketing BZ agit comme département commercial en sous-traitance. Contrat 6,500$/mois (2025) → 9,500$/mois (2026).",
    aiSuggestion: "Comprenez le partenariat stratégique entre BZ et BZ Telecom et son impact sur les opérations.",
    kpiScore: 94,
    imageUrl: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80",
    isCompleted: true,
    inKnowledgeBase: true,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 5,
    visionDany: "Le partenariat, c'est la structure. BZ Telecom vend, BZ fait le commercial. C'est gagnant-gagnant. Contrat 6,500$ → 9,500$/mois, objectif +8k$/mois MRR. C'est clair.",
    visionYannick: "Le partenariat, c'est ce qui permet à BZ Telecom de se concentrer sur le produit pendant que BZ fait le commercial. C'est efficace, c'est structuré.",
    visionFrancois: "Techniquement, le partenariat nécessite une gouvernance claire et des KPIs définis. C'est essentiel pour le succès."
  },
  {
    id: 19,
    title: "Guide de Vente BZ Telecom",
    category: "Ventes",
    description:
      "Workflow complet du parfait vendeur BZ Telecom : du lead qualifié à l’implantation. Prise de besoin structurée, scénarios de soumission, objections et scripts de réponse.",
    aiSuggestion:
      "Utilisez ce guide pour structurer chaque vente BZ Telecom : qualification, questions de découverte, propositions claires et passage à l’implantation.",
    kpiScore: 90,
    imageUrl: "https://images.unsplash.com/photo-1581090464777-f3220bbe1b8c?w=800&q=80",
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 4,
    visionDany:
      "Un vendeur bien outillé peut livrer une expérience BZ Telecom impeccable, même sans 10 ans d’expérience. Ce guide doit l’accompagner à chaque étape.",
    visionYannick:
      "On veut que chaque nouveau vendeur puisse suivre ce guide et être efficace rapidement. Pas d’improvisation, juste une méthode claire qui respecte le client.",
    visionFrancois:
      "Plus la prise de besoin est structurée, moins il y a de surprises côté facturation et opérations. Ce guide réduit les risques et augmente la qualité.",
  },
  {
    id: 20,
    title: 'Plan d’action Felix Avril–mai 2026',
    category: 'Commercial',
    description:
      'Plan court terme (60 jours) pour structurer le tunnel des ventes (CRM), augmenter la conversion et renforcer la documentation PRIsME en continu. Felix pilote l’exécution gouvernée; Martin valide les arbitrages.',
    aiSuggestion:
      'Déployez un tunnel des ventes “CRM” mesuré (leads, soumissions, pipeline, conversion) et documentez chaque décision dans PRIsME pour accélérer l’adoption et la preuve.',
    kpiScore: 89,
    imageUrl: 'https://images.unsplash.com/photo-1556761175-4b46a572b786?w=800&q=80',
    isCompleted: false,
    scoreDany: 4,
    scoreYannick: 4,
    scoreFrancois: 4,
    visionDany:
      'PRIsME sert d’instrument de transformation : décisions documentées, adoption mesurée du tunnel CRM, et preuves “avant/après”.',
    visionYannick:
      'On vise la conversion via un tunnel clair : CRM comme source de vérité opérationnellement instrumentée (mais gouvernée via PRIsME).',
    visionFrancois:
      'Le plan reste un cadre de gouvernance : cadence, mesures et artefacts. On compile ensuite vers PRIsME officiel après validation.',
  }
];
